<header>
	@if (showMainNav()) {
		<div class="meta-navigation">
			<div class="logo">
				<a routerLink="/workflow.do?from=menu&to=home"
				   class="defaultLink">
					<img src="portallogo.do?doOriginal=1">
				</a>
			</div>
			<nav>
				<bas-nav-search-field></bas-nav-search-field>

				<div class="nav-action"
				     [class.active]="prefsActive()"
				     [pTooltip]="preferencesTooltip()"
				     tooltipPosition="bottom">
					<a routerLink="/workflow.do?from=menu&to=preferences">
						<mat-icon svgIcon="settings"></mat-icon>
					</a>
				</div>

				<bas-nav-basket class="nav-action" [class.active]="basketActive()"></bas-nav-basket>

				<div class="nav-action" [class.active]="contactActive()"
				     [pTooltip]="'image.metanav.contact.alt' | msgKey"
				     tooltipPosition="bottom">
					<a [routerLink]="'image.metanav.contact.email' | msgKey">
						<mat-icon svgIcon="letter"></mat-icon>
					</a>
				</div>

				<div class="logout"
				     [pTooltip]="'image.metanav.logout.alt' | msgKey"
				     tooltipPosition="bottom">
					<a routerLink="/logout.do"
					   (click)="logout()">
						<mat-icon svgIcon="logout"></mat-icon>
					</a>
				</div>
			</nav>
		</div>

		<nav>
			<div class="main-navigation primaryCiColor">
				<ul>
					@for (topItems of items(); track topItems.id) {
						@if (topItems.name === 'root') {
							@for (item of topItems.children; track item.id) {
								<bas-nav-item [item]="item"></bas-nav-item>
							}
						} @else {
							<bas-nav-item [item]="topItems"></bas-nav-item>
						}
					}
				</ul>
				<bas-nav-quick></bas-nav-quick>
			</div>
		</nav>
	} @else {
		<div class="logo login">
			<img src="page/style/css/theme/img/logo.png">
		</div>
	}
</header>
